// ============================================
// WebSocket Context for App-Wide Access
//
// 2026-04-20: migrated from PartyKit (useWebSocketExtensions) to Supabase
// Realtime (useExtensionRealtime). Hook API is identical so all 18 call
// sites continue working without changes. Keep this file's name + context
// key for source-diff minimalism; the underlying transport changed but the
// consumer contract is unchanged.
//
// Old hook kept in source (client/src/hooks/useWebSocketExtensions.js)
// for easy revert until the dashboard Realtime migration has soaked for
// a week. See docs/plans/2026-04-20-dashboard-realtime-migration.md.
// ============================================

import React, { createContext, useContext } from 'react';
import { useExtensionRealtime } from '../hooks/useExtensionRealtime';

const WebSocketContext = createContext(null);

export function WebSocketProvider({ children }) {
  const ws = useExtensionRealtime();

  return (
    <WebSocketContext.Provider value={ws}>
      {children}
    </WebSocketContext.Provider>
  );
}

export function useWebSocket() {
  const context = useContext(WebSocketContext);

  if (!context) {
    throw new Error('useWebSocket must be used within a WebSocketProvider');
  }

  return context;
}

export default WebSocketContext;
